import magnifiAPIInstance from "./apiInstance";

export const illustoAccountAPIs = {
  createIllustoAccount: ({ payload }) => magnifiAPIInstance.post(`/create-illusto-account`, payload),
};
